import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'
import router from '@/router'
import { getPlatform, PLATFORM } from '@/utils/platform'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.config.responseType === 'blob') return response
    if (res.code === 401) {
      store.dispatch('user/logout')
      const platform = getPlatform()
      if (platform === PLATFORM.MINI_PROGRAM) {
        Toast('登录已过期，请关闭页面后从小程序重新进入')
      } else if (platform === PLATFORM.APP) {
        Toast('登录已过期，请返回 App 后重新进入')
        // App 渠道可通过 JSBridge 通知客户端处理登出/重新登录，具体桥接方式由 App 端约定后接入
      } else {
        Toast('登录已过期，请重新进入')
        router.replace('/login')
      }
      return Promise.reject(new Error('登录已过期'))
    }
    if (res.code !== 200) {
      Toast(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    const msg = error.response?.data?.msg || error.message || '网络异常'
    Toast(msg)
    return Promise.reject(error)
  }
)

export default service

